import { Stack } from "@volca/ui/components/ui/stack";
import { BusinessSettingsSidebarHeader } from "@/business-settings/common/business-settings-sidebar-header";
import { BusinessSettingsSidebarWrapper } from "@/business-settings/common/business-settings-sidebar-wrapper";
import { SignupSourceCodeInfo } from "@/business-settings/common/signup-source-code-info";
import { SIDEBAR_MODES } from "@/business-settings/constants";
import { useBusinessSettingsSidebar } from "@/business-settings/context/business-settings-sidebar-context";
import {
  calcReferralSourceStatus,
  ReferralSourceStatusBadge,
} from "@/business-settings/referral-sources/referral-source-status-badge";
import { useGetReferralSource } from "@/referral-sources/query";
import { ReferralSourceForm } from "./referral-source-form";
import { ReferralSourceSidebarSkeleton } from "./referral-source-sidebar-skeleton";

export interface ReferralSourceSidebarProps {
  mode: (typeof SIDEBAR_MODES)[keyof typeof SIDEBAR_MODES];
  referralSourceId: string | undefined;
  businessId: string;
}

export const ReferralSourceSidebar = ({
  mode,
  referralSourceId,
  businessId,
}: ReferralSourceSidebarProps) => {
  const { resetSidebar } = useBusinessSettingsSidebar();

  const { data: referralSource, isLoading } = useGetReferralSource(
    businessId,
    referralSourceId,
  );

  if (isLoading) {
    return <ReferralSourceSidebarSkeleton />;
  }

  return (
    <BusinessSettingsSidebarWrapper>
      <BusinessSettingsSidebarHeader
        headerText="Referral source"
        name={referralSource?.name || "New source"}
        onClose={resetSidebar}
        actions={
          referralSource && (
            <ReferralSourceStatusBadge
              status={calcReferralSourceStatus(referralSource)}
              className="me-2"
            />
          )
        }
      />

      <div className="overflow-auto">
        <Stack gap={8} className="w-full p-6">
          <ReferralSourceForm
            mode={mode}
            referralSource={referralSource}
            businessId={businessId}
          />

          {referralSource && (
            <SignupSourceCodeInfo
              businessId={businessId}
              signupSource={referralSource}
            />
          )}
        </Stack>
      </div>
    </BusinessSettingsSidebarWrapper>
  );
};
